import { SerializableParam, selectorFamily, useRecoilValue } from 'recoil';
import { InvoiceService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { AttachedDocument } from 'types';

type DocumentParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string;
    voucherPoId: string;
} & SerializableParam;

export const invoiceDocuments = selectorFamily<AttachedDocument[], DocumentParams>({
    key: 'invoiceDocuments',
    get: ({ accountId, vendorId, invoiceId, voucherPoId }) =>
        async ({ get }) => {
            get(refreshState(invoiceDocuments({ accountId, vendorId, invoiceId, voucherPoId }).key))
            if (get(isAuthenticated) && accountId && vendorId && voucherPoId) {
                const service = new InvoiceService();
                const data = await service.getInvoiceDocuments(accountId, vendorId, invoiceId, voucherPoId);
                return data;
            }
            return [];
        }
});

export const useInvoiceDocuments = (accountId: string, vendorId: string, invoiceId: string, voucherPoId: string) =>
    useRecoilValue(invoiceDocuments({ accountId, vendorId, invoiceId, voucherPoId }));

export const useRefreshInvoiceDocuments = (accountId: string, vendorId: string, invoiceId: string, voucherPoId: string) =>
    useSetRefreshState(invoiceDocuments({ accountId, vendorId, invoiceId, voucherPoId }));